<div
  class="aprova-recaptcha"
  [class.aprova-recaptcha--center]="horizontalPosition === 'center'"
  [class.aprova-recaptcha--right]="horizontalPosition === 'right'"
>
  <div>
    <re-captcha
      [formControl]="recaptchaFormControl"
      [siteKey]="recaptchaSiteKey"
      required
    ></re-captcha>

    <div class="aprova-recaptcha__error-box">
      @if (hasError) {
      <p class="aprova-recaptcha__error-message">
        {{ errorMessageInternal }}
      </p>
      }
    </div>
  </div>
</div>
